import { useState } from 'react';
import './App.css';
import Header from './component/header/header';
import Form from './component/todoform/todoform';
import List from './component/todolist/list';
import Tabs from './component/controllers/tab';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function App() {
  const [todos, setTodos] = useState([
    {
      id: Date.now() + "Complete JavaScript Course",
      isCompleted: true,
      name: "Complete JavaScript Course",
      date: Date.now()
    },
    {
      id: Date.now() + "Jog around the park 3x",
      isCompleted: false,
      name: "Jog around the park 3x",
      date: Date.now()
    },
    {
      id: Date.now() + "10 minutes meditation",
      isCompleted: false,
      name: "10 minutes meditation",
      date: Date.now()
    },
    {
      id: Date.now() + "Read for 1 hour",
      isCompleted: false,
      name: "Read for 1 hour",
      date: Date.now()
    },
    {
      id: Date.now() + "Pick up groceries",
      isCompleted: false,
      name: "Pick up groceries",
      date: Date.now()
    },
    {
      id: Date.now() + "Complete Todo App on Frontend Mentor",
      isCompleted: true,
      name: "Complete Todo App on Frontend Mentor",
      date: Date.now()
    }
  ]);
  const [filters, setFilters] = useState(todos);
  const [stg, setStg] = useState("All");
  const [itemCount, setItemCount ] = useState(todos.length);
  const [modes, setModes] = useState(true);

  
  const addNewTodo = (note) => {
    const oldTodo = todos;
    const newTodo = {
      id: Date.now() + note,
      isCompleted: false,
      name: note,
      date: Date.now() + note
    }
    oldTodo.push(newTodo);
    setTodos(oldTodo)
    setFilters(oldTodo)
    setItemCount(oldTodo.length)
    onFiltering(stg)
  }
  const markCompleted = (id) => {
    let mark = todos
    let li = mark.find(list=>{
        return list.id === id;
      });
    if (li.isCompleted){
      li.isCompleted = false;
    }else{

     li.isCompleted = true;
    }
      
    
    setTodos(mark);
    setFilters(mark);
    onFiltering(stg);
  }

  const onDelete = (id) => {
    let mark = todos
    let li = mark.findIndex(list => {
      return list.id === id;
    });
    mark.splice(li, 1);    
    setTodos(mark);
    setFilters(mark);
    onFiltering(stg)
  }

  const onFiltering = (id) => {
    if (id === "Active"){
      let active = todos.filter((newList, index)=>{
        return newList.isCompleted === false
      });
      setFilters(active);
      setItemCount(active.length);
    }else if (id === "Completed"){
      let complete = todos.filter((newList, index) => {
        return newList.isCompleted === true;
      });
      setFilters(complete);
      setItemCount(complete.length);
    }else if (id === "All"){
      let active = todos.filter((newList, index) => {
        return newList;
      });
      setFilters(active);
      setItemCount(active.length);
    }
  }
  
  const handleMoves = (result) => {
    console.log(result);
    const items = Array.from(filters);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    if(stg === "All"){
      setTodos(items);
    }
    setFilters(items);
  }

  const clearCompleted = () => {
    const list = todos;
    const comp = list.filter(nlist => {
      return !nlist.isCompleted;
    });
    setTodos(comp);
    if(stg === "Completed"){
      setFilters([]);
      setItemCount(0)
    }
    
  }
  return (
    <div className="App">
      <div className="banner-dark" id="banner">
        
      </div>
      <div className="main">
        <div className="hold">
          <Header
            tab={stg}
            ren={onFiltering}
            modes={modes}
            setModes={setModes}
          />
          <Form addDo={addNewTodo} />
          <div className="shade" >
            <DragDropContext onDragEnd={handleMoves}>
              <Droppable droppableId="chars">
                {(provided) => (
                  <div className="chars" {...provided.droppableProps} ref={provided.innerRef}>
                    {filters.map((tdItem, index)=>{
                      return(
                        <Draggable key={tdItem.id} draggableId={tdItem.id} index={index}>
                          {(provided) => (
                            <List 
                              key={index}
                              id={index}
                              modes={modes}
                              setModes={setModes}
                              list={tdItem.name}
                              isDone={tdItem.isCompleted}
                              mark = {markCompleted}
                              del = {onDelete}
                              time = {tdItem.id}
                              provided={provided}
                            />
                          )}
                        </Draggable>
                      );
                      
                    }
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            <Tabs 
              move = {onFiltering}
              stage = {stg}
              setStage = {setStg}
              count = {itemCount}
              modes={modes}
              setModes={setModes}
              clear={clearCompleted}
            />
          </div>
          <p className={ modes ? "drag_dark" : "drag_lite"}>Drag and drop to reorder list</p>
        </div>
        <div class="attribution">
          Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">Frontend Mentor</a>.
          Coded by <a href="asof.cf">PhantomOz</a>.
        </div>
      </div>
      
    </div>
  );
}

export default App;
